import { formatSIAPageCT, formatEventOccurrence, formatMenuItems, formatAgenda, formatOrgaEvent } from './ContentFormatter';
export default class HttpCMSAdapter {
  constructor(httpClient, headers, cmsURL) {
    this.httpClient = httpClient;
    this.headers = headers;
    this.cmsURL = cmsURL;
  }
  fetchMenuItems(languageKey, onSuccess, history) {
    const url = `${this.cmsURL}/${languageKey}/api/menu`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => {
        const menuItems = formatMenuItems(data, history, languageKey);
        return onSuccess(menuItems);
      }
    });
  }
  async fetchMenuItemsV2(languageKey, history) {
    const url = `${this.cmsURL}/${languageKey}/api/menu`;
    const data = await this.httpClient.asyncRequest({
      method: 'GET',
      url: url,
      config: this.headers
    });
    return formatMenuItems(data, history, languageKey);
  }
  fetchMenuItemsByOrganization(languageKey, organizationCode, onSuccess, history) {
    const url = `${this.cmsURL}/${languageKey}/api/menu/${organizationCode}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => onSuccess(formatMenuItems(data, history, languageKey))
    });
  }
  fetchMenuItemsBenchmarking(languageKey, onSuccess, history) {
    const url = `${this.cmsURL}/${languageKey}/api/benchmarking/menu`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => onSuccess(formatMenuItems(data, history, languageKey))
    });
  }
  searchArticles(languageKey, params, onSuccess) {
    const url = `${this.cmsURL}/${languageKey}/api/article/search${params}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => onSuccess(data)
    });
  }
  async searchArticlesV2(languageKey, params) {
    const url = `${this.cmsURL}/${languageKey}/api/article/search${params}`;
    const data = await this.httpClient.asyncRequest({
      method: 'GET',
      url: url,
      config: this.headers
    });
    return data;
  }
  articlesFilters(languageKey, onSuccess) {
    const url = `${this.cmsURL}/${languageKey}/api/article/filters`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => onSuccess(data)
    });
  }
  async articlesFiltersV2(languageKey) {
    const url = `${this.cmsURL}/${languageKey}/api/article/filters`;
    const data = await this.httpClient.asyncRequest({
      method: 'GET',
      url: url,
      config: this.headers
    });
    return data;
  }
  fetchOrgaArticlesFilters(languageKey, onSuccess, organizationCode) {
    const url = `${this.cmsURL}/${languageKey}/api/article/filters?organisation=${organizationCode}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => onSuccess(data)
    });
  }
  async fetchOrgaArticlesFiltersV2(languageKey, organizationCode) {
    const url = `${this.cmsURL}/${languageKey}/api/article/filters?organisation=${organizationCode}`;
    const data = await this.httpClient.asyncRequest({
      method: 'GET',
      url: url,
      config: this.headers
    });
    return data;
  }
  fetchNoMenu(language, onSuccess) {
    const url = `${this.cmsURL}/${language}/api/nomenu`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: data => {
        return onSuccess(data);
      }
    });
  }
  async fetchNoMenuV2(language) {
    const url = `${this.cmsURL}/${language}/api/nomenu`;
    const data = await this.httpClient.asyncRequest({
      method: 'GET',
      url: url,
      config: this.headers
    });
    return data;
  }
  fetchOrgaNoMenu(language, onSuccess, organizationCode) {
    const url = `${this.cmsURL}/${language}/api/nomenu/${organizationCode}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: data => {
        return onSuccess(data);
      }
    });
  }
  fetchAliases(language, alias, onSuccess) {
    const url = `${this.cmsURL}/${language}/api/aliases?alias=${alias}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: data => onSuccess(data.data)
    });
  }
  async fetchAliasesV2(language, alias) {
    const url = `${this.cmsURL}/${language}/api/aliases?alias=${alias}`;
    const data = this.httpClient.asyncRequest({
      method: 'GET',
      url: url,
      config: this.headers
    });
    return data;
  }
  fetchEvent(languageKey, node_id, onSuccess) {
    const url = `${this.cmsURL}/${languageKey}/api/agenda/node/${node_id}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => {
        return onSuccess(formatEventOccurrence(data));
      }
    });
  }
  fetchNode(languageKey, node_id, onSuccess, organizationCode) {
    const url = `${this.cmsURL}/${languageKey}/api/node/${node_id}${organizationCode ? `?organisation=${organizationCode}` : ''}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => {
        let response = data;
        if (data?.content_type === 'sia_page') response = formatSIAPageCT(data);
        if (data?.content_type === 'sektion_page') response = formatSIAPageCT(data);
        onSuccess(response);
      }
    });
  }
  fetchNodeBM(languageKey, node_id, onSuccess) {
    const url = `${this.cmsURL}/${languageKey}/api/benchmarking/node/${node_id}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => {
        if (data?.content_type === 'sia_page') return onSuccess(formatSIAPageCT(data));
        if (data?.content_type === 'sektion_page') return onSuccess(formatSIAPageCT(data));
        return onSuccess(data);
      }
    });
  }
  fetchForm(languageKey, form_id, onSuccess) {
    const url = `${this.cmsURL}/${languageKey}/webform_rest/${form_id}/fields`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => onSuccess(data)
    });
  }
  fetchTerms(languageKey, term_id, onSuccess) {
    const url = `${this.cmsURL}/${languageKey}/api/terms/${term_id}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => onSuccess(data)
    });
  }
  fetchOrgaTerms(languageKey, term_id, onSuccess, organizationCode) {
    const url = `${this.cmsURL}/${languageKey}/api/terms/${term_id}?organisation=${organizationCode}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => onSuccess(data)
    });
  }
  submitForm(languageKey, form_id, values, onSuccess, onError) {
    const url = `${this.cmsURL}/${languageKey}/webform_rest/submit`;
    this.httpClient.request({
      method: 'POST',
      url: url,
      data: {
        webform_id: form_id,
        ...values
      },
      config: {
        headers: {
          ...this.headers.headers,
          'Content-Type': 'application/json'
        }
      },
      onSuccess: data => onSuccess(data),
      onError: data => onError(data),
      ignoreError: true
    });
  }
  fetchNodeByHash(languageKey, hash, onSuccess, organizationCode) {
    const url = `${this.cmsURL}/${languageKey}/api/getByHash/${hash}${organizationCode ? `?organisation=${organizationCode}` : ''}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => {
        if (data?.content_type === 'sia_page') return onSuccess(formatSIAPageCT(data));
        if (data?.content_type === 'sektion_page') return onSuccess(formatSIAPageCT(data));
        if (data?.content_type === 'organisation_event') return onSuccess(formatOrgaEvent(data));
        return onSuccess(data);
      }
    });
  }
  fetchAgenda(languageKey, onSuccess, translate, events_number) {
    const url = `${this.cmsURL}/${languageKey}/api/events${events_number ? `?events_number=${events_number}` : ''}`;
    setTimeout(() => {
      this.httpClient.request({
        method: 'GET',
        url: url,
        config: this.headers,
        onSuccess: ({
          data
        }) => onSuccess(formatAgenda(data, translate)),
        ignoreLoader: !!events_number
      });
    }, 300);
  }
  fetchParagraph(onSuccess, languageKey, id) {
    const url = `${this.cmsURL}/${languageKey}/api/paragraph/${id}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => {
        onSuccess(data);
      },
      ignoreLoader: true
    });
  }
  globalSearch(onSuccess, languageKey, text) {
    const url = `${this.cmsURL}/${languageKey}/api/search?text=${text}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => onSuccess(data)
    });
  }
  fetchOrgaHomePage(onSuccess, organizationCode, languageKey) {
    const url = `${this.cmsURL}/${languageKey}/api/homepage/${organizationCode}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => {
        if (data?.content_type === 'sia_page') return onSuccess(formatSIAPageCT(data));
        if (data?.content_type === 'sektion_page') return onSuccess(formatSIAPageCT(data));
        return onSuccess(data);
      }
    });
  }
  async fetchMasterpreisHomepage(languageKey) {
    const url = `${this.cmsURL}/${languageKey}/api/masterpreis/homepage`;
    const data = await this.httpClient.asyncRequest({
      method: 'GET',
      url: url,
      config: this.headers
    });
    return data;
  }
  async fetchMasterpreisArticles(languageKey) {
    const url = `${this.cmsURL}/${languageKey}/api/masterpreis/articles`;
    const data = await this.httpClient.asyncRequest({
      method: 'GET',
      url: url,
      config: this.headers
    });
    return data;
  }
  fetchOrgaAgenda(onSuccess, translate, organizationCode) {
    const url = `${this.cmsURL}/api/events?organisation=${organizationCode}`;
    setTimeout(() => {
      this.httpClient.request({
        method: 'GET',
        url: url,
        config: this.headers,
        onSuccess: ({
          data
        }) => onSuccess(formatAgenda(data, translate))
      });
    }, 300);
  }
  fetchOrgaEvent(node_id, onSuccess, organizationCode) {
    const url = `${this.cmsURL}/api/agenda/node/${node_id}${organizationCode ? `?organisation=${organizationCode}` : ''}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => {
        return onSuccess(formatOrgaEvent(data));
      }
    });
  }
  fetchOrganizationData(organizationCode, languageKey, onSuccess) {
    const url = `${this.cmsURL}/${languageKey}/api/organisation/${organizationCode}`;
    this.httpClient.request({
      method: 'GET',
      url: url,
      config: this.headers,
      onSuccess: ({
        data
      }) => onSuccess(data)
    });
  }
}